module.exports = __webpack_public_path__ + "static/media/sample.3eadcb76.srt";